// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".layout[data-v-41d93838] {\n  background: #f5f5f5;\n  padding: 0.26667rem;\n  min-height: 100vh;\n}\n.layout .mb-10[data-v-41d93838] {\n  margin-bottom: 0.26667rem;\n}\n", ""]);
// Exports
module.exports = exports;
